// import type — лише тип: імпорт стирається при компіляції,
// тож циклу модулів @utils <-> @pressure-core у рантаймі немає
import type { PressureTableSortState } from "@pressure-core";
import { TableFilterFieldNameMap } from "./serialize-table-filters.util";

/**
 * Серіалізує серверне сортування у рядок параметра `sort` (формат Spring Data:
 * "field,asc"). Ключ поля перейменовується у ключ бекенду (як у фільтрах,
 * valueField -> поле бекенду). Дефолтний стан ("none" або порожнє поле) ->
 * порожній рядок, тож параметр `sort` не додається до запиту.
 */
export const serializeTableSort = (
  sort: PressureTableSortState,
  fieldNameMap: TableFilterFieldNameMap = {},
): string => {
  if (!sort || sort.order === "none" || !sort.field) {
    return "";
  }

  const field: string = fieldNameMap[sort.field] ?? sort.field;
  return `${field},${sort.order}`;
};
